import script from "./GpsScene.vue?vue&type=script&lang=js"
export * from "./GpsScene.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__